export default "__VITE_ASSET__a85ec198__"